(function () {
  'use strict';

  if (window.__bbBundleBuilderLoaded) return;
  window.__bbBundleBuilderLoaded = true;

  var COLOR_OPTION_NAMES = ['اللون', 'لون', 'color', 'colour'];

  function openThemeCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    function tryOpenT4S() {
      if (window.T4SThemeSP && window.T4SThemeSP.Drawer && window.jQuery_T4NT) {
        var $drawer = window.jQuery_T4NT('#t4s-mini_cart');
        if ($drawer.length) {
          window.T4SThemeSP.Drawer.opend($drawer);
          return true;
        }
      }
      return false;
    }

    if (tryOpenT4S()) return;

    var genericDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
    if (genericDrawer) {
      document.dispatchEvent(new CustomEvent('cart:open'));
      genericDrawer.classList.add('is-open', 'active', 'drawer--open');
      genericDrawer.removeAttribute('hidden');
      return;
    }

    window.location.href = '/cart';
  }

  var SIZE_OPTION_NAMES = ['المقاس', 'مقاس', 'size'];

  function isSizeOption(name) {
    if (!name) return false;
    var n = name.trim().toLowerCase();
    return SIZE_OPTION_NAMES.indexOf(n) !== -1;
  }

  var descOverlay = null;
  function ensureDescOverlay() {
    if (descOverlay) return descOverlay;
    descOverlay = document.createElement('div');
    descOverlay.className = 'bb-sizechart-overlay';
    descOverlay.setAttribute('hidden', '');
    descOverlay.innerHTML =
      '<div class="bb-sizechart-modal bb-desc-modal">' +
        '<button type="button" class="bb-sizechart-close" aria-label="إغلاق"><svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M18.3 5.71L12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.3 19.71 2.89 18.3 9.17 12 2.89 5.71 4.3 4.29l6.29 6.3 6.29-6.3z"/></svg></button>' +
        '<div class="bb-desc-body"><h3 class="bb-desc-title"></h3><p class="bb-desc-text"></p></div>' +
      '</div>';
    document.body.appendChild(descOverlay);
    descOverlay.querySelector('.bb-sizechart-close').addEventListener('click', function () {
      descOverlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    });
    descOverlay.addEventListener('click', function (e) {
      if (e.target === descOverlay) {
        descOverlay.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    });
    return descOverlay;
  }
  function openDescription(title, desc) {
    var overlay = ensureDescOverlay();
    overlay.querySelector('.bb-desc-title').textContent = title;
    overlay.querySelector('.bb-desc-text').textContent = desc || 'لا يوجد وصف متاح لهذا المنتج.';
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  var sizeChartOverlay = null;
  function ensureSizeChartOverlay() {
    if (sizeChartOverlay) return sizeChartOverlay;
    sizeChartOverlay = document.createElement('div');
    sizeChartOverlay.className = 'bb-sizechart-overlay';
    sizeChartOverlay.setAttribute('hidden', '');
    sizeChartOverlay.innerHTML =
      '<div class="bb-sizechart-modal">' +
        '<button type="button" class="bb-sizechart-close" aria-label="إغلاق"><svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M18.3 5.71L12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.3 19.71 2.89 18.3 9.17 12 2.89 5.71 4.3 4.29l6.29 6.3 6.29-6.3z"/></svg></button>' +
        '<div class="bb-sizechart-body"></div>' +
      '</div>';
    document.body.appendChild(sizeChartOverlay);
    sizeChartOverlay.querySelector('.bb-sizechart-close').addEventListener('click', closeSizeChart);
    sizeChartOverlay.addEventListener('click', function (e) {
      if (e.target === sizeChartOverlay) closeSizeChart();
    });
    return sizeChartOverlay;
  }
  function closeSizeChart() {
    if (sizeChartOverlay) sizeChartOverlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
  function openSizeChart(url, type) {
    var overlay = ensureSizeChartOverlay();
    var body = overlay.querySelector('.bb-sizechart-body');
    if (type === 'image') {
      body.innerHTML = '<img src="' + url + '" alt="جدول المقاسات">';
    } else {
      body.innerHTML = '<iframe src="' + url + '" frameborder="0"></iframe>';
    }
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function parseJsonAttr(str) {
    if (!str) return null;
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  function isColorOption(name) {
    if (!name) return false;
    var n = name.trim().toLowerCase();
    return COLOR_OPTION_NAMES.indexOf(n) !== -1;
  }

  function findVariant(variants, optionValues) {
    return variants.find(function (v) {
      var vals = [v.option1, v.option2, v.option3].filter(Boolean);
      return optionValues.every(function (val, idx) { return vals[idx] === val; });
    });
  }

  // Best-effort guess of a CSS color from an option value name (for swatches)
  function guessColor(name) {
    var map = {
      'أبيض': '#f5f5f5', 'اسود': '#111', 'أسود': '#111', 'اسمر': '#6b4a33',
      'بيج': '#e8dcc8', 'رمادي': '#9c9c9c', 'كحلي': '#1c2b4a', 'ازرق': '#3a6ea5',
      'أزرق': '#3a6ea5', 'احمر': '#b5342f', 'أحمر': '#b5342f', 'اخضر': '#4c7a4c',
      'أخضر': '#4c7a4c', 'وردي': '#e59aa8', 'بنفسجي': '#8d6cab', 'موف': '#b39ddb',
      'فيروزي': '#3fb8af', 'بصلي': '#e9a1a1', 'رصاصي': '#7a7a7a', 'فاتح': '#e6e6e6',
      'لبني': '#a9b8e8', 'برتقالي': '#e07b39', 'بني': '#6b4a33'
    };
    var key = (name || '').trim();
    return map[key] || null;
  }

  function initBundleSection(root) {
    if (root.dataset.bbInitialized === 'true') return;
    root.dataset.bbInitialized = 'true';

    var requiredTotal = parseInt(root.dataset.requiredTotal, 10) || 4;
    var halfLabel = root.dataset.halfLabel || 'نص كم';
    var fullLabel = root.dataset.fullLabel || 'كت';
    var manualCompare = parseFloat(root.dataset.manualCompare) || 0;
    var manualFinal = parseFloat(root.dataset.manualFinal) || 0;
    var pricingMode = root.dataset.pricingMode || 'percentage';
    var discountPercentage = parseFloat(root.dataset.discountPercentage) || 0;
    var colorSelectorType = root.dataset.colorSelectorType || 'variant_image_round';
    var sizeSelectorType = root.dataset.sizeSelectorType || 'block';

    var cards = root.querySelectorAll('[data-bb-card]');
    var submitBtn = root.querySelector('[data-bb-submit]');
    var comparePriceEl = root.querySelector('[data-bb-compare-price]');
    var finalPriceEl = root.querySelector('[data-bb-final-price]');
    var noteEl = root.querySelector('[data-bb-note]');
    var countHalfEl = root.querySelector('[data-count-half]');
    var countFullEl = root.querySelector('[data-count-full]');
    var countTotalEl = root.querySelector('[data-count-total]');
    var progressTotal = root.querySelector('.bb-progress-item[data-group="total"]');
    var btnOrigText = submitBtn ? submitBtn.textContent.trim() : '';

    var selected = { half: [], full: [] };
    var chosenVariant = {}; // productId -> variant object currently active on the card
    var cardVariantData = {}; // productId -> { options, variants, selectedOptions }

    // ---- Sticky Bar setup ----
    var stickyBar = root.querySelector('[data-bb-sticky]');
    var stickyThumbs = root.querySelector('[data-bb-sticky-thumbs]');
    var stickyProgress = root.querySelector('[data-bb-sticky-progress]');
    var stickyCompare = root.querySelector('[data-bb-sticky-compare]');
    var stickyFinal = root.querySelector('[data-bb-sticky-final]');
    var stickySubmit = root.querySelector('[data-bb-sticky-submit]');

    if (stickyBar) stickyBar.removeAttribute('hidden');

    if (stickyBar && 'IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('bb-sticky-visible', entry.isIntersecting);
        });
      }, { threshold: 0.05 });
      sectionObserver.observe(root);
    } else if (stickyBar) {
      stickyBar.classList.add('bb-sticky-visible');
    }

    if (stickySubmit) {
      stickySubmit.addEventListener('click', function () {
        var mainBtn = root.querySelector('[data-bb-submit]');
        if (mainBtn) mainBtn.click();
      });
    }

    function updateStickyBar(sumCents, finalCents, complete) {
      if (!stickyBar) return;

      // Prices
      if (stickyCompare) {
        stickyCompare.textContent = formatMoneyCents(sumCents);
        stickyCompare.style.display = (sumCents !== finalCents && sumCents > 0) ? '' : 'none';
      }
      if (stickyFinal) stickyFinal.textContent = formatMoneyCents(finalCents > 0 ? finalCents : sumCents);

      // Thumbnails
      if (stickyThumbs) {
        stickyThumbs.innerHTML = '';
        var total = requiredTotal;
        var filled = 0;
        cards.forEach(function (card) {
          var group = card.dataset.group;
          var id = card.dataset.productId;
          if (selected[group].indexOf(id) !== -1) {
            var img = document.createElement('img');
            img.className = 'bb-sticky-thumb';
            var cardImgEl = card.querySelector('.bb-card-img img');
            img.src = cardImgEl ? cardImgEl.src : '';
            img.alt = card.dataset.title || '';
            stickyThumbs.appendChild(img);
            filled++;
          }
        });
        var remaining = total - filled;
        for (var i = 0; i < remaining; i++) {
          var empty = document.createElement('div');
          empty.className = 'bb-sticky-thumb bb-thumb-empty';
          stickyThumbs.appendChild(empty);
        }
      }

      // Progress text
      if (stickyProgress) {
        var remainingTotal = Math.max(requiredTotal - (selected.half.length + selected.full.length), 0);
        if (complete) {
          stickyProgress.textContent = '✓ الباندل جاهز';
          stickyProgress.style.color = '#2e7d32';
        } else {
          stickyProgress.textContent = 'باقي: ' + remainingTotal + ' قطعة';
          stickyProgress.style.color = '#777';
        }
      }

      if (stickySubmit) stickySubmit.disabled = !complete;
    }

    function formatMoney(amount) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
        return Shopify.formatMoney(Math.round(amount * 100), window.theme_money_format);
      }
      return amount.toFixed(2);
    }
    function formatMoneyCents(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
        return Shopify.formatMoney(cents, window.theme_money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function totalSelectedCount() {
      return selected.half.length + selected.full.length;
    }

    // ---- Build inline option pills for a card ----
    function buildCardOptions(card) {
      var productId = card.dataset.productId;
      var options = parseJsonAttr(card.dataset.options);
      var variants = parseJsonAttr(card.dataset.variants);
      var variantImages = parseJsonAttr(card.dataset.variantImages) || [];
      var wrap = card.querySelector('[data-bb-card-options]');
      if (!wrap) return;

      if (!options || !variants || (options.length <= 1 && variants.length <= 1)) {
        var v = variants && variants[0];
        chosenVariant[productId] = v || { id: parseInt(card.dataset.variantId, 10), price: parseInt(card.dataset.price, 10), available: card.dataset.available !== 'false' };
        return;
      }

      var imageMap = {};
      variantImages.forEach(function (vi) { imageMap[vi.id] = vi.image; });

      var colorSwatches = parseJsonAttr(card.dataset.colorSwatches) || [];
      var swatchMap = {};
      colorSwatches.forEach(function (s) { swatchMap[s.value] = s; });

      var defaultVariant = variants.find(function (v) { return v.id === parseInt(card.dataset.variantId, 10); }) || variants[0];
      var selectedOptions = [defaultVariant.option1, defaultVariant.option2, defaultVariant.option3].filter(Boolean);
      cardVariantData[productId] = { options: options, variants: variants, selectedOptions: selectedOptions, imageMap: imageMap, swatchMap: swatchMap };
      chosenVariant[productId] = defaultVariant;

      renderCardOptions(card);
    }

    function renderCardOptions(card) {
      var productId = card.dataset.productId;
      var data = cardVariantData[productId];
      var wrap = card.querySelector('[data-bb-card-options]');
      if (!data || !wrap) return;
      wrap.innerHTML = '';

      // If this product has no Color option but does have a Size option,
      // reserve the same space a Color row would take so the Size row
      // lines up with cards of products that do have colors.
      var hasColorOption = data.options.some(function (o) { return isColorOption(o.name); });
      var hasSizeOption = data.options.some(function (o) { return isSizeOption(o.name); });
      if (!hasColorOption && hasSizeOption) {
        var colorPlaceholder = document.createElement('div');
        colorPlaceholder.className = 'bb-option-block bb-option-block-placeholder';
        colorPlaceholder.setAttribute('aria-hidden', 'true');
        colorPlaceholder.setAttribute('data-bb-row', 'color');
        colorPlaceholder.innerHTML =
          '<p class="bb-option-label"><span class="bb-option-label-primary"><span class="bb-option-label-name">&nbsp;<span class="bb-option-colon">:</span></span><span class="bb-option-value">&nbsp;</span></span></p>' +
          '<div class="bb-option-values"><span class="bb-swatch bb-swatch-round"></span></div>';
        wrap.appendChild(colorPlaceholder);
      }

      data.options.forEach(function (opt, optIndex) {
        var block = document.createElement('div');
        block.className = 'bb-option-block';
        if (isColorOption(opt.name)) {
          block.setAttribute('data-bb-row', 'color');
        } else if (isSizeOption(opt.name)) {
          block.setAttribute('data-bb-row', 'size');
        }

        var label = document.createElement('p');
        label.className = 'bb-option-label';
        var displayName = opt.name;
        if (isColorOption(opt.name)) {
          displayName = 'اللون';
        } else if (isSizeOption(opt.name)) {
          displayName = 'المقاس';
        }
        label.innerHTML = '<span class="bb-option-label-primary"><span class="bb-option-label-name">' + displayName + '<span class="bb-option-colon">:</span></span><span class="bb-option-value">' + (data.selectedOptions[optIndex] || '') + '</span></span>';

        if (isSizeOption(opt.name)) {
          var scBtn = document.createElement('button');
          scBtn.type = 'button';
          scBtn.className = 'bb-sizechart-btn';
          scBtn.textContent = 'جدول المقاسات';
          if (card.dataset.sizeChartUrl) {
            scBtn.addEventListener('click', function (e) {
              e.stopPropagation();
              openSizeChart(card.dataset.sizeChartUrl, card.dataset.sizeChartType);
            });
          } else {
            // No size chart configured for this product: keep the same
            // reserved space so cards stay aligned, just make it invisible.
            scBtn.classList.add('bb-sizechart-btn-placeholder');
            scBtn.tabIndex = -1;
            scBtn.setAttribute('aria-hidden', 'true');
          }
          label.appendChild(scBtn);
        }
        block.appendChild(label);

        var useSwatch = isColorOption(opt.name);
        var style = useSwatch ? colorSelectorType : sizeSelectorType;
        var useDropdown = style === 'dropdown';
        var isSwatchStyle = style.indexOf('color_swatch') === 0 || style.indexOf('variant_image') === 0;

        function applyVariant(val) {
          data.selectedOptions[optIndex] = val;
          var newVariant = findVariant(data.variants, data.selectedOptions);
          if (newVariant) {
            chosenVariant[productId] = newVariant;
            card.dataset.price = newVariant.price;
            card.dataset.available = newVariant.available;
            var priceEl = card.querySelector('[data-bb-card-price]');
            if (priceEl) priceEl.textContent = formatMoneyCents(newVariant.price);
            // Update card image to the variant's featured image
            var cardImg = card.querySelector('.bb-card-img img');
            var newImgUrl = data.imageMap[newVariant.id];
            if (cardImg && newImgUrl) {
              var newSrc = newImgUrl.replace('width=100', 'width=400');
              cardImg.classList.add('bb-img-changing');
              setTimeout(function () {
                cardImg.src = newSrc;
                cardImg.classList.remove('bb-img-changing');
                if (card._updateSliderIndex) card._updateSliderIndex(newSrc);
              }, 150);
            }
          }
          renderCardOptions(card);
          render();
          scheduleEqualize();
        }

        if (useDropdown) {
          var selectWrap = document.createElement('div');
          selectWrap.className = 'bb-option-select-wrap';

          var select = document.createElement('select');
          select.className = 'bb-option-select';
          opt.values.forEach(function (val) {
            var testOptions = data.selectedOptions.slice();
            testOptions[optIndex] = val;
            var matched = findVariant(data.variants, testOptions);
            var o = document.createElement('option');
            o.value = val;
            o.textContent = val + ((!matched || !matched.available) ? ' (غير متاح)' : '');
            if (data.selectedOptions[optIndex] === val) o.selected = true;
            select.appendChild(o);
          });
          select.addEventListener('click', function (e) { e.stopPropagation(); });
          select.addEventListener('change', function (e) {
            e.stopPropagation();
            applyVariant(select.value);
          });

          var chevron = document.createElement('span');
          chevron.className = 'bb-option-select-chevron';
          chevron.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"/></svg>';

          selectWrap.appendChild(select);
          selectWrap.appendChild(chevron);
          block.appendChild(selectWrap);
          wrap.appendChild(block);
          return;
        }

        var valuesWrap = document.createElement('div');
        valuesWrap.className = 'bb-option-values';
        if (isSwatchStyle) valuesWrap.classList.add('bb-option-values-swatch');
        if (style === 'radio' || style === 'radio_full') {
          valuesWrap.classList.add('bb-option-values-radio');
        }

        opt.values.forEach(function (val) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.setAttribute('aria-label', opt.name + ': ' + val);
          pill.title = val;

          var testOptions = data.selectedOptions.slice();
          testOptions[optIndex] = val;
          var matched = findVariant(data.variants, testOptions);
          var isSelected = data.selectedOptions[optIndex] === val;

          if (isSwatchStyle) {
            pill.className = 'bb-swatch';
            pill.classList.add(style.indexOf('round') !== -1 ? 'bb-swatch-round' : 'bb-swatch-square');

            var bgSet = false;
            if (style.indexOf('variant_image') === 0) {
              var swatchVariant = matched || data.variants.find(function (v) {
                return [v.option1, v.option2, v.option3].indexOf(val) !== -1;
              });
              var imgUrl = swatchVariant ? data.imageMap[swatchVariant.id] : null;
              if (imgUrl) { pill.style.backgroundImage = 'url(' + imgUrl + ')'; bgSet = true; }
            } else {
              var native = data.swatchMap[val];
              if (native && native.image) { pill.style.backgroundImage = 'url(' + native.image + ')'; bgSet = true; }
              else if (native && native.color) { pill.style.background = native.color; bgSet = true; }
            }
            if (!bgSet) pill.textContent = val.charAt(0);
          } else if (style === 'radio' || style === 'radio_full') {
            pill.className = 'bb-option-radio' + (style === 'radio_full' ? ' bb-option-radio-full' : '');
            pill.innerHTML = '<span class="bb-radio-dot"></span><span class="bb-radio-text">' + val + '</span>';
          } else if (style === 'circle') {
            pill.className = 'bb-option-pill bb-option-pill-circle';
            pill.textContent = val;
          } else {
            pill.className = 'bb-option-pill';
            if (style === 'block_round') pill.classList.add('bb-option-pill-round');
            pill.textContent = val;
          }

          if (isSelected) pill.classList.add('bb-option-pill-selected');
          if (!matched || !matched.available) pill.classList.add('bb-option-pill-unavailable');

          pill.addEventListener('click', function (e) {
            e.stopPropagation();
            if (pill.classList.contains('bb-option-pill-unavailable')) return;
            applyVariant(val);
          });

          valuesWrap.appendChild(pill);
        });

        block.appendChild(valuesWrap);
        wrap.appendChild(block);
      });
    }

    function updateCardStates() {
      var isFull = totalSelectedCount() >= requiredTotal;
      cards.forEach(function (card) {
        var group = card.dataset.group;
        var id = card.dataset.productId;
        var isSelected = selected[group].indexOf(id) !== -1;
        card.classList.toggle('bb-selected', isSelected);
        if (!isSelected && isFull) {
          card.classList.add('bb-disabled');
        } else {
          card.classList.remove('bb-disabled');
        }
      });
    }

    function updateProgress() {
      countHalfEl.textContent = selected.half.length;
      countFullEl.textContent = selected.full.length;
      if (countTotalEl) countTotalEl.textContent = totalSelectedCount();
      if (progressTotal) progressTotal.classList.toggle('bb-complete', totalSelectedCount() >= requiredTotal);
    }

    function calcSumCents() {
      var total = 0;
      cards.forEach(function (card) {
        var group = card.dataset.group;
        var id = card.dataset.productId;
        if (selected[group].indexOf(id) !== -1) {
          var v = chosenVariant[id];
          total += v ? v.price : parseInt(card.dataset.price, 10);
        }
      });
      return total;
    }

    function isComplete() {
      return totalSelectedCount() === requiredTotal;
    }

    function render() {
      updateProgress();
      updateCardStates();

      var sumCents = calcSumCents();

      if (pricingMode === 'percentage') {
        var finalCents = Math.round(sumCents * (1 - discountPercentage / 100));
        comparePriceEl.textContent = formatMoneyCents(sumCents);
        finalPriceEl.textContent = formatMoneyCents(finalCents);
        comparePriceEl.style.display = discountPercentage > 0 ? '' : 'none';
      } else {
        var hasManualPricing = manualFinal > 0;
        if (hasManualPricing) {
          comparePriceEl.textContent = manualCompare > 0 ? formatMoney(manualCompare) : formatMoneyCents(sumCents);
          finalPriceEl.textContent = formatMoney(manualFinal);
          comparePriceEl.style.display = (manualCompare > 0 && manualCompare !== manualFinal) ? '' : 'none';
        } else {
          comparePriceEl.style.display = 'none';
          finalPriceEl.textContent = formatMoneyCents(sumCents);
        }
      }

      var complete = isComplete();
      submitBtn.disabled = !complete;

      if (complete) {
        if (noteEl) noteEl.textContent = noteEl.dataset.readyText || '';
      } else {
        var remainingTotal = Math.max(requiredTotal - totalSelectedCount(), 0);
        var msg = 'باقي تختار ' + remainingTotal + ' قطعة (من أي كولكشن)';
        if (noteEl) noteEl.textContent = noteEl.dataset.pendingPrefix ? noteEl.dataset.pendingPrefix + remainingTotal : msg;
      }

      // Update sticky bar
      var stickyFinalCents = pricingMode === 'percentage'
        ? Math.round(sumCents * (1 - discountPercentage / 100))
        : (manualFinal > 0 ? Math.round(manualFinal * 100) : sumCents);
      updateStickyBar(sumCents, stickyFinalCents, complete);
    }

    function toggleSelect(card) {
      var v = chosenVariant[card.dataset.productId];
      var available = v ? v.available : card.dataset.available !== 'false';
      if (!available) return;

      var group = card.dataset.group;
      var id = card.dataset.productId;
      var idx = selected[group].indexOf(id);

      if (idx !== -1) {
        selected[group].splice(idx, 1);
      } else {
        if (totalSelectedCount() >= requiredTotal) return;
        selected[group].push(id);
      }
      render();
    }

    cards.forEach(function (card) {
      buildCardOptions(card);
      initCardSlider(card);

      card.addEventListener('click', function () {
        toggleSelect(card);
      });

      var descBtn = card.querySelector('[data-bb-desc-open]');
      if (descBtn) {
        descBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openDescription(card.dataset.title, card.dataset.desc);
        });
      }
    });

    // ---- Keep title / price / options rows aligned across every card ----
    // Fixed min-heights break as soon as a title needs an extra line, so
    // instead we measure the tallest element in each row across ALL cards
    // and stretch the rest to match. Re-runs on resize/font-load since
    // wrapping depends on the rendered column width.
    var alignRowGroups = ['.bb-card-title', '.bb-card-price', '[data-bb-row="color"]', '[data-bb-row="size"]'];
    function equalizeCardRows() {
      alignRowGroups.forEach(function (selector) {
        var els = root.querySelectorAll(selector);
        els.forEach(function (el) { el.style.height = ''; });
      });
      alignRowGroups.forEach(function (selector) {
        var els = root.querySelectorAll(selector);
        var max = 0;
        els.forEach(function (el) { max = Math.max(max, el.offsetHeight); });
        els.forEach(function (el) { el.style.height = max + 'px'; });
      });
    }

    var equalizeTimer = null;
    function scheduleEqualize() {
      clearTimeout(equalizeTimer);
      equalizeTimer = setTimeout(equalizeCardRows, 50);
    }

    scheduleEqualize();
    window.addEventListener('resize', scheduleEqualize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleEqualize);
    }

    function initCardSlider(card) {
      var allImages = parseJsonAttr(card.dataset.allImages) || [];
      if (allImages.length <= 1) return;

      var imgEl = card.querySelector('[data-bb-main-img]');
      var prevBtn = card.querySelector('[data-bb-slide="-1"]');
      var nextBtn = card.querySelector('[data-bb-slide="1"]');
      var dotsWrap = card.querySelector('[data-bb-slide-dots]');
      if (!imgEl) return;

      var currentIndex = 0;

      // Build dots
      allImages.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'bb-slide-dot' + (i === 0 ? ' bb-dot-active' : '');
        dot.addEventListener('click', function (e) { e.stopPropagation(); goTo(i); });
        if (dotsWrap) dotsWrap.appendChild(dot);
      });

      function goTo(index) {
        currentIndex = (index + allImages.length) % allImages.length;
        imgEl.classList.add('bb-img-changing');
        setTimeout(function () {
          imgEl.src = allImages[currentIndex];
          imgEl.classList.remove('bb-img-changing');
        }, 120);
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.bb-slide-dot').forEach(function (d, i) {
            d.classList.toggle('bb-dot-active', i === currentIndex);
          });
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(currentIndex + 1); });

      // Override the variant image swap: also update currentIndex to match
      var origApply = card._applyVariantImage;
      card._updateSliderIndex = function (imgUrl) {
        var idx = allImages.findIndex ? allImages.findIndex(function (u) { return u === imgUrl; }) : -1;
        if (idx !== -1) currentIndex = idx;
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.bb-slide-dot').forEach(function (d, i) {
            d.classList.toggle('bb-dot-active', i === currentIndex);
          });
        }
      };
    }

    // ---- Add to cart ----
    submitBtn.addEventListener('click', function () {
      if (!isComplete()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'جاري الإضافة...';

      var bundleId = 'bundle-' + Date.now();
      var items = [];

      cards.forEach(function (card) {
        var group = card.dataset.group;
        var id = card.dataset.productId;
        if (selected[group].indexOf(id) !== -1) {
          var v = chosenVariant[id];
          items.push({
            id: v ? v.id : parseInt(card.dataset.variantId, 10),
            quantity: 1,
            properties: {
              '_bundle_id': bundleId,
              '_bundle_group': group
            }
          });
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('bundle:added', { detail: { bundleId: bundleId } }));
          openThemeCartDrawer();
          submitBtn.disabled = false;
          submitBtn.textContent = btnOrigText;
        })
        .catch(function (err) {
          console.error(err);
          alert('حصل خطأ أثناء إضافة الباندل للسلة، حاول تاني.');
          submitBtn.disabled = false;
          submitBtn.textContent = btnOrigText;
        });
    });

    render();
  }

  document.querySelectorAll('.bb-section').forEach(initBundleSection);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.bb-section');
    if (root) initBundleSection(root);
  });
})();
